import React from 'react';

import Alert from '@react/react-spectrum/Icon/Alert';
import Button from '@react/react-spectrum/Button';
import Heading from '@react/react-spectrum/Heading';
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger';
import Tooltip from '@react/react-spectrum/Tooltip';

import './LabeledValue.scss';

export default function LabeledValue({ label, value, emptyMessage }) {
  return (
    <div className="labeled-value">
      <Heading variant="subtitle3">{label}</Heading>
      <div>
        <span className="value">{value || '--'}</span>
        {!value && emptyMessage && (
          <OverlayTrigger placement="right">
            <Button
              variant="tool"
              icon={<Alert style={{ color: '#c9252d' }} />}
            />
            <Tooltip variant="error">{emptyMessage}</Tooltip>
          </OverlayTrigger>
        )}
      </div>
    </div>
  );
}
